export default __webpack_public_path__ + "static/media/website.faa5238c.svg";